import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import { deleteBillingAddress } from 'Redux/ducks/auth';
import CountryNames from 'Helpers/Geo/CountryNameLocales';
import store from 'Redux/store';

function AddressDisplay({ showDelete, userBilling, editAction, intl: { formatMessage } }) {
  const deleteAddress = () => {
    store.dispatch(deleteBillingAddress());
  };

  return (
    <div className="account-table-row address-display">
      <div className="account-table-row-title address-display-title">
        <FormattedMessage id="address-display.line-item.title" defaultMessage="Billing Name & Address" />
      </div>
      <div className="account-table-row-content address-display-details-container">
        <div className="account-table-details-container address-display-details">
          {isEmpty(userBilling) ?
            <FormattedMessage id="address-display.empty-address" defaultMessage="Add your name and billing address to assist us in preventing fraudulent payments." />
            :
            <div className="setting-item-address">
              {userBilling.customerName &&
                <div className="setting-item-address-title">
                  {userBilling.customerName}
                </div>
              }
              {userBilling.address1 &&
                <div>
                  {userBilling.address1}
                </div>
              }
              {userBilling.address2 &&
                <div>
                  {userBilling.address2}
                </div>
              }
              {userBilling.locality &&
                <div>
                  {userBilling.locality}
                </div>
              }
              {userBilling.administrativeArea &&
                <div>
                  {userBilling.administrativeArea}
                </div>
              }
              {userBilling.postalCode &&
                <div>
                  {userBilling.postalCode}
                </div>
              }
              {userBilling.countryCode &&
                <div>
                  {formatMessage(CountryNames[userBilling.countryCode])}
                </div>
              }
            </div>
          }
        </div>
        {editAction &&
          <div className="account-table-action-container address-display-buttons-container text-right">
            <button className="btn account-table-action-button" onClick={editAction}>
              {isEmpty(userBilling) ?
                <FormattedMessage id="address-display.add-address" defaultMessage="Add Billing Details" />
                :
                <FormattedMessage id="address-display.edit-address" defaultMessage="Edit Billing Details" />
              }
            </button>
            {!isEmpty(userBilling) && showDelete &&
              <>
                <hr className="mb-1 mt-1" />
                <button className="btn account-table-action-button" onClick={() => deleteAddress()}>
                  <FormattedMessage id="address-display.remove-address" defaultMessage="Remove Billing Address" />
                </button>
              </>
            }
          </div>
        }
      </div>
    </div>
  );
}

export default injectIntl(AddressDisplay);

AddressDisplay.propTypes = {
  userBilling: PropTypes.shape({}),
  editAction: PropTypes.func,
  showDelete: PropTypes.bool,
};

AddressDisplay.defaultProps = {
  userBilling: {},
  editAction: null,
  showDelete: false,
};
